import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '@core/core.module';
import { PaymentCompleteComponent } from './payment-complete.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [PaymentCompleteComponent],
  exports: [PaymentCompleteComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, CoreModule, FontAwesomeModule, TranslateModule]
})
export class PaymentCompleteModule { }
